import { render, staticRenderFns } from "./EditingBar.vue?vue&type=template&id=7c6fca35&"
import script from "./EditingBar.vue?vue&type=script&lang=js&"
export * from "./EditingBar.vue?vue&type=script&lang=js&"
import style0 from "./EditingBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports